window.addEventListener('DOMContentLoaded', (event) => {
    const pageHeader = document.querySelector('.page-header__main-nav'),
        pageBody = document.querySelector('.page-body'),
        burgerWrap = document.querySelector('.burger-wrapper');

        burgerWrap.addEventListener('click', function H() {
            let __this = this;
            __this.classList.toggle('open');
            pageHeader.classList.toggle('show');
            pageHeader.classList.toggle('pattern');
            pageBody.classList.toggle('show');
        });

    const customLinksHeader = document.querySelectorAll('.page-header .flowing-scroll');

    customLinksHeader.forEach(item => {
        item.addEventListener('click', function() {
            if(pageHeader.classList.contains('show')) {
                pageHeader.classList.remove('show');
            }

            if(pageBody.classList.contains('show')) {
                pageBody.classList.remove('show');
            }

            if(burgerWrap.classList.contains('open')) {
                burgerWrap.classList.remove('open');
            }
        });
    });
});
